import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** `clsx` + `tailwind-merge` — the de-facto pattern for composing
 *  Tailwind class names with conditional logic. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Format a number with thousand-separators. e.g. 12345 → "12,345" */
export function fmtN(n: number | null | undefined): string {
  if (n == null) return '—';
  return n.toLocaleString();
}

/** Format USD cents as $X.XX. */
export function fmtCents(cents: number | null | undefined): string {
  if (cents == null) return '—';
  return `$${(cents / 100).toFixed(2)}`;
}

/** Friendly relative time. "3m", "2h", "5d", or absolute date past 30d. */
export function fmtRelative(iso: string | Date | null | undefined): string {
  if (!iso) return '—';
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  const ms = Date.now() - d.getTime();
  if (ms < 0) return d.toLocaleDateString();
  const s = Math.floor(ms / 1000);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h`;
  const days = Math.floor(h / 24);
  if (days < 30) return `${days}d`;
  return d.toLocaleDateString();
}

/** Shorten a UUID for display: "abc12345-..." */
export function shortId(id: string | null | undefined): string {
  if (!id) return '—';
  return id.slice(0, 8) + '…';
}
